import { useContext } from 'react';

import { SuiThemeContext } from '@hrworks/design-system/components';

import type { ImageSrc } from './Image.types';

const resolveSource = (source: ImageSrc | undefined, colorScheme: 'light' | 'dark') => {
  if (!source) return;
  if (typeof source === 'string') return source;

  return source[colorScheme];
};

export const useResolveImageSrc = (src: ImageSrc, fallbackSrc?: ImageSrc) => {
  const { colorScheme } = useContext(SuiThemeContext);

  return {
    src: resolveSource(src, colorScheme),
    fallbackSrc: resolveSource(fallbackSrc, colorScheme),
  };
};
